import React, { useState } from 'react';
import StatusBar from '../components/common/StatusBar';
import Cart from '../components/common/Cart';

// Composants spécifiques restaurant (à créer plus tard)
const MenuGrid = () => {
  const menuItems = [
    { id: 1, name: 'Entrées', items: [
      { id: 1, name: 'Salade César', price: 8.50, image: '🥗' },
      { id: 2, name: 'Soupe à l\'Oignon', price: 6.50, image: '🍲' },
    ]},
    { id: 2, name: 'Plats', items: [
      { id: 3, name: 'Steak Frites', price: 18.50, image: '🥩' },
      { id: 4, name: 'Poulet Rôti', price: 15.50, image: '🍗' },
    ]},
    { id: 3, name: 'Desserts', items: [
      { id: 5, name: 'Crème Brûlée', price: 7.50, image: '🍮' },
      { id: 6, name: 'Tarte Tatin', price: 8.50, image: '🍎' },
    ]},
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-800">Menu</h3>
      </div>
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-6">
          {menuItems.map((category) => (
            <div key={category.id}>
              <h4 className="text-md font-semibold text-gray-700 mb-3">{category.name}</h4>
              <div className="grid grid-cols-2 gap-3">
                {category.items.map((item) => (
                  <div
                    key={item.id}
                    className="bg-gray-50 rounded-lg p-3 cursor-pointer hover:bg-blue-50 transition-colors border"
                  >
                    <div className="text-center">
                      <div className="text-2xl mb-2">{item.image}</div>
                      <h5 className="font-medium text-sm text-gray-800 mb-1">{item.name}</h5>
                      <div className="text-lg font-bold text-green-600">{item.price.toFixed(2)} €</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const OrderTable = () => {
  const tables = [
    { id: 1, number: 'Table 1', status: 'active', orders: 2, total: 45.80 },
    { id: 2, number: 'Table 2', status: 'empty', orders: 0, total: 0 },
    { id: 3, number: 'Table 3', status: 'active', orders: 1, total: 23.50 },
    { id: 4, number: 'Table 4', status: 'reserved', orders: 0, total: 0 },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-800">Tables</h3>
      </div>
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="grid grid-cols-2 gap-3">
          {tables.map((table) => (
            <div
              key={table.id}
              className={`p-3 rounded-lg border cursor-pointer transition-colors ${
                table.status === 'active' 
                  ? 'bg-green-50 border-green-200 hover:bg-green-100' 
                  : table.status === 'reserved'
                  ? 'bg-yellow-50 border-yellow-200 hover:bg-yellow-100'
                  : 'bg-gray-50 border-gray-200 hover:bg-gray-100'
              }`}
            >
              <div className="text-center">
                <div className="text-lg font-semibold text-gray-800">{table.number}</div>
                <div className={`text-xs px-2 py-1 rounded-full inline-block mt-1 ${
                  table.status === 'active' 
                    ? 'bg-green-100 text-green-700' 
                    : table.status === 'reserved'
                    ? 'bg-yellow-100 text-yellow-700'
                    : 'bg-gray-100 text-gray-600'
                }`}>
                  {table.status === 'active' ? 'Active' : 
                   table.status === 'reserved' ? 'Réservée' : 'Libre'}
                </div>
                {table.orders > 0 && (
                  <div className="mt-2 text-sm">
                    <div className="text-gray-600">{table.orders} commande(s)</div>
                    <div className="font-semibold text-green-600">{table.total.toFixed(2)} €</div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const OrderStatus = () => {
  const orders = [
    { id: 1, table: 'Table 1', items: ['Steak Frites', 'Salade César'], status: 'preparing', time: '5 min' },
    { id: 2, table: 'Table 3', items: ['Poulet Rôti'], status: 'ready', time: '2 min' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="p-3 border-b bg-gray-50">
        <h3 className="text-md font-semibold text-gray-800">Commandes en cours</h3>
      </div>
      <div className="p-3">
        <div className="space-y-2">
          {orders.map((order) => (
            <div
              key={order.id}
              className={`p-2 rounded-lg border ${
                order.status === 'ready' 
                  ? 'bg-green-50 border-green-200' 
                  : 'bg-yellow-50 border-yellow-200'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-sm">{order.table}</div>
                  <div className="text-xs text-gray-600">{order.items.join(', ')}</div>
                </div>
                <div className="text-right">
                  <div className={`text-xs px-2 py-1 rounded-full ${
                    order.status === 'ready' 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-yellow-100 text-yellow-700'
                  }`}>
                    {order.status === 'ready' ? 'Prêt' : 'En préparation'}
                  </div>
                  <div className="text-xs text-gray-500 mt-1">{order.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const RestaurantLayout = ({ 
  // États
  commandes,
  currentCommande,
  selectedLineIndex,
  currentCommandeIndex,
  
  // Fonctions
  addProductToCurrentCommande,
  setSelectedLineIndex,
  updateItemQuantity,
  removeItemFromCommande,
  clearCurrentCommande,
  createNewCommande,
  switchToCommande,
  saveSale,
  handlePaymentComplete
}) => {
  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Barre de statut avec statut des commandes */}
      <div className="bg-white border-b border-gray-200">
        <StatusBar />
        <OrderStatus />
      </div>
      
      {/* Contenu principal */}
      <div className="flex-1 flex gap-4 p-4 overflow-hidden">
        {/* Colonne gauche - Menu */}
        <div className="flex-1">
          <MenuGrid />
        </div>
        
        {/* Colonne droite - Tables et Panier */}
        <div className="w-96 flex flex-col gap-4">
          {/* Tables */}
          <div className="h-64">
            <OrderTable />
          </div>
          
          {/* Panier */}
          <div className="flex-1">
            <Cart 
              layoutType="restaurant" 
              currentCommande={currentCommande}
              selectedLineIndex={selectedLineIndex}
              onLineSelect={setSelectedLineIndex}
              onUpdateQuantity={updateItemQuantity}
              onRemoveItem={removeItemFromCommande}
              onClearCommande={clearCurrentCommande}
              onSaveSale={saveSale}
              onPaymentComplete={handlePaymentComplete}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantLayout; 